import KeyCode from '../../util/keycode'
import ko from 'knockout'
function removeZero (num) {
  if (isNaN(num)) {
    return num
  }
  let result = Number(num)
  return result
}
// 数字转成千分位
function toThousands (num, isKeepZero) {
  if (isNaN(num)) {
    return num
  }
  let orialNum = num
  if (!isKeepZero) {
    num = Math.abs(num)
  }
  num = (num || 0).toString()
  let result = ''
  let nums = num.split('.')
  // 整数部分
  let integerPart = nums[0]
  // 小数部分
  let decimalPart = nums.length > 1 ? nums[1] : 0
  while (integerPart.length > 3) {
    result = ',' + integerPart.slice(-3) + result
    integerPart = integerPart.slice(0, integerPart.length - 3)
  }
  if (integerPart) {
    result = integerPart + result
  }
  if (isKeepZero) {
    result += '.' + decimalPart
  } else {
    if (Number(decimalPart)) {
      // 末位去零
      result += '.' + Number('0.' + decimalPart).toString().split('.')[1]
    }
  }
  if (orialNum < 0) {
    result = '-' + result
  }
  return result
}
const getAllColumns = (cols, forTableHead = false) => {
  const columns = cols;
  const result = [];
  columns.forEach((column) => {
    if (column.children && column.children.length > 0) {
      if (forTableHead) result.push(column);
      result.push.apply(result, getAllColumns(column.children, forTableHead));
    } else {
      result.push(column);
    }
  });
  return result;
};
const convertToRowsHeader = (columns, fixedType = false) => {
  // 锁定列要重复处理，确认下，先以最简单的columns为例子
  // const originColumns = fixedType ? fixedType === 'left' ? deepCopy(convertColumnOrder(columns, 'left')) : deepCopy(convertColumnOrder(columns, 'right')) : deepCopy(columns);
  const originColumns = columns
  let maxLevel = 1;
  const traverse = (column, parent) => {
    if (parent) {
      column.level = parent.level + 1;
      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }
    if (!column._show) {
      column._show = ko.observable(true)
    }
    if (!column._needRender) {
      column._needRender = ko.observable(true)
    }
    // 对于不显示的列则不进行计算
    if (!ko.utils.unwrapObservable(column._show)) {
      column.colspan = 0
    } else {
      if (column.children && column.children.length > 0) {
        let colSpan = 0;
        column.children.forEach((subColumn) => {
          traverse(subColumn, column);
          colSpan += subColumn.colspan;
        });
        column.colspan = colSpan;
      } else {
        column.colspan = 1;
      }
    }
  };
  originColumns.forEach((column) => {
    column.level = 1;
    traverse(column);
  });

  const rows = [];
  for (let i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  const allColumns = getAllColumns(originColumns, true);
  allColumns.forEach((column) => {
    if (!column.children || column.children.length === 0) {
      column.rowspan = maxLevel - column.level + 1;
    } else {
      column.rowspan = 1;
    }
    rows[column.level - 1].push(column);
  });
  // debugger
  return rows;
};
var util = {
  formatText: (row, col) => {
    let result
    if (typeof row.ref === 'function' && col.field) {
      result = row.getValue(col.field) // 使用ko属性数值改变才能被监听到
    } else {
      result = row[col.field]
    }
    return result
  },
  defaultFormatText: (row, col) => {
    let result
    if (typeof row.ref === 'function' && col.field) {
      result = row.ref(col.field)() // 使用ko属性数值改变才能被监听到
    } else {
      result = row[col.field]
    }
    if (col.dataType) {
      if (col.dataType === 'date') {
        if (result) {
          result = new Date(result)._format('yyyy-MM-dd')
        }
      } else if (col.dataType === 'datetime') {
        if (result) {
          result = new Date(result)._format('yyyy-MM-dd hh:mm:ss')
        }
      } else if (col.dataType === 'financial') { // 财务数字
        if (result) {
          result = toThousands(result)
        }
      } else if (col.dataType === 'removeZero') { // 金额 单价类（自动末位0去掉，是几位小数就按几位小数显示）
        if (result) {
          result = removeZero(result)
        }
      }
    }
    return result
  },
  matches: function (element, selector) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
          var matches = element.parentNode.querySelectorAll(s)
          var i = matches.length
          while (--i >= 0 && matches.item(i) !== this) { }
          return i > -1
        }
    }

    return element.matches(selector)
  },
  findClosest: function (element, selector) {
    if (!element) {
      return null
    }
    if (util.matches(element, selector)) {
      return element
    } else {
      return util.findClosest(element.parentNode, selector)
    }
  },
  Aria: {
    KeyCode: KeyCode
  },
  convertToRowsHeader,
  getAllColumns
}
export {
  toThousands
}
export default util



// WEBPACK FOOTER //
// ./src/components/grid/gridutil.js